import { Card } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { ManagementCountryList_countries_edges_node } from "@saleor/countries/types/ManagementCountryList";
import { CountryListUrlSortField } from "@saleor/countries/urls";
import { sectionNames } from "@saleor/intl";
import { FilterPageProps, ListActions, PageListProps, SortPage, TabPageProps } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import CountryList from "../CountryList/CountryList";
import {
    CountryFilterKeys,
    CountryListFilterOpts,
    createFilterStructure  } from "./filters";

export interface CountryListPageProps
    extends PageListProps,
    ListActions,
    FilterPageProps<CountryFilterKeys, CountryListFilterOpts>,
    SortPage<CountryListUrlSortField>,
    TabPageProps {
        country: ManagementCountryList_countries_edges_node[];
        onBack: () => void;
        toatlCount:number;
    }
const CountryListPage:React.FC<CountryListPageProps> = ({
    currencySymbol,
    filterOpts,
    initialSearch,
    onAdd,
    onBack,
    onFilterChange,
    onSearchChange,
    currentTab,
    onAll,
    onTabChange,
    onTabDelete,
    onTabSave,
    tabs,
    toatlCount,
    ...listProps

}) =>{
    const intl = useIntl();
    const structure = createFilterStructure(intl, filterOpts);
    return(
        <Container>
            <AppHeader onBack={onBack}>
                <FormattedMessage {...sectionNames.configuration} />
            </AppHeader>
            <PageHeader title={intl.formatMessage(sectionNames.countries)+"("+toatlCount+")"}>
                <Button onClick={onAdd} color="primary" variant="contained">
                <FormattedMessage
                    defaultMessage="Create New Country"
                    description="button"
                />
                </Button>
            </PageHeader>
            <Card>
                <FilterBar
                    allTabLabel={intl.formatMessage({
                        defaultMessage: "All Countries",
                        description: "tab name"
                    })}
                    currencySymbol={currencySymbol}
                    currentTab={currentTab}
                    filterStructure={structure}
                    initialSearch={initialSearch}
                    searchPlaceholder={intl.formatMessage({
                        defaultMessage: "Search Country"
                    })}
                    tabs={tabs}
                    onAll={onAll}
                    onFilterChange={onFilterChange}
                    onSearchChange={onSearchChange}
                    onTabChange={onTabChange}
                    onTabDelete={onTabDelete}
                    onTabSave={onTabSave}
                />
                <CountryList {...listProps} />
            </Card>
        </Container>

    );
};
export default CountryListPage;